import { render, staticRenderFns } from "./InfoBlockDialog.vue?vue&type=template&id=de8dc8d6"
import script from "./InfoBlockDialog.vue?vue&type=script&lang=js"
export * from "./InfoBlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports